"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSelectedTextWidgets = void 0;
var slate_1 = require("slate");
var EditorWidgetRegistry_1 = require("Project/QwilrEditor/WidgetRegistry/EditorWidgetRegistry");
var Utils_1 = require("Project/QwilrEditor/Utils");
var GetTraitConfig_1 = require("@CommonFrontend/WidgetRegistry/Utils/GetTraitConfig");
var widgetStyle_1 = require("@CommonFrontend/Utils/widgetStyle");
function getSelectedTextWidgets(editor, colorProvider, blockStore) {
    if (editor.selection === null || slate_1.Range.isCollapsed(editor.selection)) {
        return [];
    }
    var selectedBlocks = (0, Utils_1.getSelectedBlocks)(editor);
    var elementsAndConfigs = getTextElementsAndConfigs(selectedBlocks);
    var widgetsInfo = elementsAndConfigs.map(function (_a) {
        var _b;
        var element = _a.element, widgetConfig = _a.widgetConfig;
        var styleableConfig = (0, GetTraitConfig_1.getTraitConfig)({ widgetType: widgetConfig.type, traitName: "styleable" });
        var blockStyle = styleableConfig ? blockStore.blockStyleStore.model[styleableConfig.styleKey] : {};
        var overrides = "style" in element ? element.style : {};
        var style = (0, widgetStyle_1.widgetStyle)({
            blockStyle: blockStyle,
            colorProvider: colorProvider,
            overrides: overrides,
            styleableProperties: styleableConfig === null || styleableConfig === void 0 ? void 0 : styleableConfig.properties,
            paragraphColor: (_b = blockStore.blockStyleStore.getElementStyle("p")) === null || _b === void 0 ? void 0 : _b["color"],
        });
        return { element: element, widgetConfig: widgetConfig, styleableConfig: styleableConfig, style: style, overrides: overrides };
    });
    return widgetsInfo;
}
exports.getSelectedTextWidgets = getSelectedTextWidgets;
function getTextElementsAndConfigs(selectedBlocks) {
    var e_1, _a;
    var elementsAndConfigs = [];
    var hasTextContent = false;
    try {
        for (var selectedBlocks_1 = __values(selectedBlocks), selectedBlocks_1_1 = selectedBlocks_1.next(); !selectedBlocks_1_1.done; selectedBlocks_1_1 = selectedBlocks_1.next()) {
            var blockEntry = selectedBlocks_1_1.value;
            var element = blockEntry[0];
            var config = (0, EditorWidgetRegistry_1.getGenericConfigByType)(element.type);
            if (!config || config.nodeType !== "textElement") {
                return [];
            }
            hasTextContent = hasTextContent || slate_1.Node.string(element).length > 0;
            elementsAndConfigs.push({ element: element, widgetConfig: config });
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (selectedBlocks_1_1 && !selectedBlocks_1_1.done && (_a = selectedBlocks_1.return)) _a.call(selectedBlocks_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    if (!hasTextContent) {
        return [];
    }
    return elementsAndConfigs;
}
